import React from "react";
import { useIntl } from "react-intl";
import Button from "../UI/Button/Button";
import { ContentfulButtonColour, ContentfulCtaTarget } from "../../ContentfulTypes";
import Image from "../UI/Image/Image";
import { Icon, MainTitle } from "./styles";

interface Props {
  isSmall?: boolean;
  iconTestId?: string;
  titleTestId?: string;
  buttonTestId?: string;
  image: Record<string, any>;
  title: string;
  buttonText: string;
  buttonColour: ContentfulButtonColour;
  onClick?: (...args) => void;
  route?: ContentfulCtaTarget;
  url?: string;
  buttonId?: string;
}

const HorizontalCardContent = ({
  isSmall = false,
  iconTestId,
  titleTestId,
  buttonTestId,
  image,
  title,
  buttonText,
  buttonColour,
  onClick,
  route,
  url,
  buttonId,
}: Props) => {
  const { locale } = useIntl();
  return (
    <>
      <Icon
        $isSmall={isSmall}
        data-testid={iconTestId}
      >
        <Image image={image} />
      </Icon>
      <MainTitle
        $isSmall={isSmall}
        data-testid={titleTestId}
      >
        {title}
      </MainTitle>
      <Button
        buttonText={buttonText}
        buttonColour={buttonColour}
        buttonSize="standard"
        locale={locale}
        onClick={onClick}
        id={buttonId}
        route={route}
        url={url}
        data-testid={buttonTestId}
      />
    </>
  );
};

export default HorizontalCardContent;
